export default "__VITE_ASSET__DQjJ5ZCA__"